export default {
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      mostrar: this.value,
      objetoFiltro: {}
    };
  },
  methods: {
    /**
     * Função base para não ter muitas duplicadas nos componentes de filtro,
     * facilitando assim a assosiação dos objetos no formato { chave: Number, descricao: String }
     * @param {Number, String} index - o index da listagem que está no autocomplete
     * @param {String} nomeObjeto - nome do objeto que está presente na variável objetoFiltro
     * @param {Array<Object>} listagem - listagem onde nós vamos extrair a chave
     */
    selecionarChave(index, nomeObjeto, listagem, nomeChave = "chave") {
      if ([undefined, null, "", -1].includes(index)) {
        this.objetoFiltro[nomeObjeto].chave = "";
        return;
      }

      this.objetoFiltro[nomeObjeto].chave = listagem[index][nomeChave];
    },
    limpar() {
      this.objetoFiltro = JSON.parse(JSON.stringify(this.objetoFiltroVazio));
      this.$emit("limpar-filtro");
    },
    fecharFiltro() {
      this.$emit("input", false);
    },
    setFiltro(obj) {
      if (Object.keys(obj).length === 0) return;
      this.objetoFiltro = { ...obj };
    }
  },
  watch: {
    value() {
      this.mostrar = this.value;
    }
  }
};
